import React, { useState, useEffect, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import Modal from "react-modal";
import { toast } from "react-toastify";
import html2pdf from "html2pdf.js";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const FarmerInvoiceList = (props) => {
  const { addForm, sId } = props;
  const printRef = useRef();
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");
  const [totalGoodAmount, setTotalGoodAmount] = useState("0.00");
  const [totalBadAmount, setTotalBadAmount] = useState("0.00");
  const [logoBase64, setLogoBase64] = useState("");
  const [logoSrc, setLogoSrc] = useState("");
  const [orgData, setOrgData] = useState(null);
 


  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const { sendRequest: getfarmerInvoice } = useHttp();
  const getfarmerInvoiceDetail = () => {
    getfarmerInvoice(
      {
        url: `/api/farmerInvoice/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        // //console.log("res:", res);
        if (res) {
          setData(res);
          setAllData(res);
        }
      },
      (error) => {
        console.log("Error", error);
      }
    );
  };

  useEffect(() => {
    getfarmerInvoiceDetail();
  }, [getfarmerInvoice]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, invoiceId) => {
    e.preventDefault();

    const input = {
      invoiceId: invoiceId,
    };

    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this farmerInvoice detail?",
      onOk() {
        const orgId = localStorage.getItem("orgId");
        deleteOperation(
          {
            url: `/api/farmerInvoice/?invoiceId=${invoiceId}&orgId=${orgId}`,
            method: "DELETE",
            // body: input,
          },
          (data) => {
            if (data.success) {
              toast.success(data.success);
            }

            if (data.error) {
              //console.log("error:", error);
              toast.error(data.error);
            }
            getfarmerInvoiceDetail();
          },
          (error) => {
            //console.log("Error", error);
            toast.error(error);
            getfarmerInvoiceDetail();
          }
        );
      },
      onCancel() {
        getfarmerInvoiceDetail();
      },
    });
  };
  const handleSearch = (e) => {
    const filtertext = e.target.value.trim().toLowerCase();

    const filterdata = allData.filter(
      (item) =>
        (item.invoiceNo?.toLowerCase() || "").includes(filtertext) ||
        (item.farmerName?.toLowerCase() || "").includes(filtertext) ||
        (item.invoiceDate?.toLowerCase() || "").includes(filtertext)
    );

    setData(filterdata);
    setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "800px", // Adjust the width as needed
      // height: "80%",
      minHeight: "500px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    //console.log(data);
    const Id = data.invoiceId;
    getfarmerInvoice(
      {
        url: `/api/farmerInvoice/?orgId=${localStorage.getItem(
          "orgId"
        )}&invoiceId=${Id}`,
      },
      (res) => {
        //console.log("detail view res:", res);
        setSelectedData(res);
      },
      (error) => {
        //console.log("Error", error);
      }
    );

    setIsModalOpen(true);
  };

  const pdfContainerRef = useRef(null);
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const { sendRequest: getPdfData } = useHttp();

  const viewPdf = (data) => {
    setPdfView(true);

    const Id = data?.invoiceId;
    if (!Id) return;

    getPdfData(
      {
        url: `/api/farmerInvoice/?orgId=${localStorage.getItem(
          "orgId"
        )}&invoiceId=${Id}`,
      },
      (responseData) => {
        if (responseData) {
          setPdfData(responseData);
          console.log("PDF Data:", responseData);
        } else {
          console.warn("No data received for PDF view.");
        }
      }
    );
  };

  const generatePDF = (title) => {
    const input = printRef.current;
    if (!input) return;

    html2canvas(input, { scale: 2, useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "pt", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 20, 20, pdfWidth - 20, pdfHeight - 30);
      pdf.save(`${title || "report"}_${new Date().toISOString()}.pdf`);
    });
  };

  const totalC = (
    parseFloat(totalGoodAmount || 0) + parseFloat(totalBadAmount || 0)
  ).toFixed(2);
  const totalF = (
    parseFloat(pdfData?.inputCost || 0) +
    parseFloat(pdfData?.administrativeCost || 0)
  ).toFixed(2);

  const calculatedPayableAmount = (totalC - totalF).toFixed(2);

  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedApprovalData(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };
  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";
    // console.log(approvalStatus);

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        invoiceId: selectedApprovalData && selectedApprovalData.invoiceId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: parseInt(localStorage.getItem("orgId")),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    // console.log(data);

    updateApprovalStatus(
      {
        url: "/api/farmerInvoiceApproval/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);
        // getProcurementTemplateDetail();
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });

        setApprovalPopupVisible(false);
        setRemark("");
        getfarmerInvoiceDetail();
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  useEffect(() => {
    if (pdfData && Array.isArray(pdfData.procurements)) {
      const totalGoodAmount = pdfData.procurements
        .filter((item) => item.fruitQuality.toLowerCase() === "good")
        .reduce((sum, item) => sum + (parseFloat(item.totalAmount) || 0), 0);

      const totalBadAmount = pdfData.procurements
        .filter((item) => item.fruitQuality.toLowerCase() === "bad")
        .reduce((sum, item) => sum + (parseFloat(item.totalAmount) || 0), 0);

      setTotalGoodAmount(totalGoodAmount.toFixed(2));
      setTotalBadAmount(totalBadAmount.toFixed(2));
    } else {
      setTotalGoodAmount("0.00");
      setTotalBadAmount("0.00");
    }
  }, [pdfData]);


  const totalFinalQtySelected = selectedData?.procurements?.reduce(
    (sum, item) => sum + (parseFloat(item.finalQuantity) || 0),
    0
  );

  const totalExpenseAmountSelected = selectedData?.procurements?.reduce(
    (sum, item) => sum + (parseFloat(item.totalAmount) || 0),
    0
  );




  const formatAmount = (value) => {
    if (!value || isNaN(value)) return "0.00";
    return new Intl.NumberFormat("en-NG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  useEffect(() => {
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = `/dist/img/TomatoJOLogo.jpg?v=${Date.now()}`;

  img.onload = () => {
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    setLogoSrc(canvas.toDataURL("image/png"));
  };

  img.onerror = () => {
    console.error("Logo not found");
    setLogoSrc("");
  };
}, []);


  return (
    <>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Farmer Invoice{" "}
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary my-2 mx-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Invoice
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Invoice No</th>
                            <th>Farmer Name</th>
                            <th>Invoice Date</th>
                            {/* optional if amounts should show */}
                            {/* <th>Total Amount</th>
                    <th>Payable</th> */}
                            <th>View</th>
                            <th>Approval</th>
                            <th>Print</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.invoiceNo}</td>
                                <td>{x.farmerName}</td>
                                <td>{x.invoiceDate}</td>

                                {/* Example if numeric fields exist */}
                                {/* <td>{formatAmount(x.totalAmount)}</td>
                        <td>{formatAmount(x.payableAmount)}</td> */}

                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(x)}
                                    className="btn"
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    disabled={
                                      x.approved === 1 || x.approved === 2
                                    }
                                  >
                                    {x.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => viewPdf(x)}
                                    className="btn"
                                  >
                                    <i className="fas fa-print"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                    disabled={
                                      x.approved === 1 || x.approved === 2
                                    }
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) =>
                                      handleDelete(e, x.invoiceId)
                                    }
                                    disabled={
                                      x.approved === 1 || x.approved === 2
                                    }
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Farmer Invoice Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>

            <div className="row">
              <div className="col-md-6">
                <strong>Invoice No: </strong> {selectedData.invoiceNo}
              </div>
              <div className="col-md-6">
                <strong>Invoice Date: </strong> {selectedData.invoiceDate}
              </div>
              <div className="col-md-6">
                <strong>Farmer Name: </strong> {selectedData.farmerName}
              </div>
              <div className="col-md-6">
                <strong>Ranch Name: </strong> {selectedData.ranchName}
              </div>
              <div className="col-md-6">
                <strong>Field Name: </strong> {selectedData.fieldCode}
              </div>

              <div className="col-md-6">
                <strong>Plot No: </strong> {selectedData.plotName}
              </div>
              <div className="col-md-6">
                <strong>Total Quantity (ALL): </strong> {formatAmount(totalFinalQtySelected)}

              </div>
              <div className="col-md-6">
                <strong>Total Expense Amount: </strong>
                {formatAmount(totalExpenseAmountSelected || 0)}

              </div>
              <div className="col-md-6">
                <strong>Final Amount: </strong>
                {formatAmount(selectedData.totalAmount)}
              </div>
              <div className="col-md-6">
                <strong>Bank Name: </strong> {selectedData.bankName}
              </div>
              <div className="col-md-6">
                <strong>Account Holder Name: </strong>{" "}
                {selectedData.accountHolderName}
              </div>
              <div className="col-md-6">
                <strong>Account No: </strong> {selectedData.accountNumber}
              </div>
              <div className="col-md-6">
                <strong>IFSC Code: </strong> {selectedData.ifscCode}
              </div>
              <div className="col-md-6">
                <strong>Created Date: </strong> {selectedData.createdDate}
              </div>
            </div>

            <div className="mt-4">
              <h5>Procurements</h5>
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr.No</th>
                    <th>Fruit Quality</th>
                    <th>Total Quantity</th>
                    <th>Qty Adj. %</th>
                    <th>Final Quantity</th>
                    <th>Rate</th>
                    <th>Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData.procurements &&
                    selectedData.procurements.length ? (
                    selectedData.procurements.map((item, idx) => (
                      <tr key={item.farmerInvoiceProcurmentId || idx}>
                        <td>{idx + 1}</td>
                        <td>{item.fruitQuality}</td>
                        <td>{formatAmount(item.totalQuantity)}</td>
                        <td>{formatAmount(item.qtyAdjustmentPercentage)}</td>
                        <td>{formatAmount(item.finalQuantity)}</td>
                        <td>{formatAmount(item.rate)}</td>
                        <td>{formatAmount(item.totalAmount)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9}>No procurement data</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>

      {pdfView && (
        <Modal isOpen={true} style={customModalStyles}>
          <div className="pdf-main-container">
            {/* Close Button */}
            <div className="row no-print">
              <div className="col-md-11" />
              <div className="col-md-1 text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  onClick={() => setPdfView(false)}
                >
                  <i className="fas fa-times" />
                </button>
              </div>
            </div>

            {/* PDF Content */}
            <div
              className="pdf-container"
              style={{ margin: "0px", paddingTop: "0px" }}
              ref={(el) => {
                pdfContainerRef.current = el;
                printRef.current = el;
              }}
            >

              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      <div className="invoice p-3 mb-3">
                        {/* Header */}
                        <div className="row mb-2">
                          <div className="col-12">
                            <h4 className="fw-bold fs-3 text-center text-uppercase">
                              {logoSrc && (
                                <img
                                  src={logoSrc}
                                  width="50"
                                  height="50"
                                  alt=""
                                  style={{ marginRight: "10px" }}
                                />
                              )}
                              Farmer Invoice Details
                            </h4>
                          </div>
                        </div>

                        {/* Top Info */}
                        <div className="row invoice-info mb-4">
                          <div className="col-md-6">
                            <strong>Invoice No:</strong> {pdfData?.invoiceNo}
                            <br />
                            <strong>Invoice Date:</strong>{" "}
                            {pdfData?.invoiceDate}
                            <br />
                            <strong>Farmer Name:</strong> {pdfData?.farmerName}
                            <br />
                            <strong>Farmer No:</strong> {pdfData?.farmerNo}
                            <br />
                            <strong>Field Executive Name:</strong>{" "}
                            {pdfData?.executiveName}
                            <br />
                            <strong>Season Name:</strong>{" "}
                            {pdfData?.seasonName}
                            <br />
                            <strong>Ranch Name:</strong> {pdfData?.ranchName}
                            <br />
                          </div>
                          <div className="col-md-6">
                            <strong>Plot Numbaer:</strong> {pdfData?.plotName}
                            <br />
                            <strong>Plot Area:</strong>{" "}
                            {formatAmount(pdfData?.plotArea || 0)}{" "}
                            {pdfData?.unit}
                            <br />
                            <strong>Crop Name:</strong> {pdfData?.cropName}
                            <br />
                            {/* <strong>Variety Name:</strong>{" "}
                            {pdfData?.varietyName} */}
                            {/* <br />
                            <strong>Payment Type:</strong>{" "}
                            {pdfData?.paymentType}
                            <br /> */}
                          </div>
                        </div>

                        {/* Procurement Table */}
                        <h5 className="mb-2">Farmer Invoice</h5>
                        <div className="table-responsive">
                          <table className="table table-bordered text-center table-responsive">
                            <thead>
                              <tr>
                                <th>Sr. No</th>
                                {/* <th>Doc No.</th> */}
                                <th style={{ width: "100px" }}>Date</th>
                                <th>Total Qty</th>
                                <th>Quality</th>
                                <th>Qty Adj. %</th>
                                <th>Final Qty</th>
                                <th>Rate/Kg</th>
                                <th>Total Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {pdfData?.procurements?.length ? (
                                pdfData.procurements.map((item, idx) => (
                                  <tr
                                    key={item.farmerInvoiceProcurmentId || idx}
                                  >
                                    <td>{idx + 1}</td>
                                    {/* <td>{item.docNo}</td> */}
                                    <td style={{ width: "100px" }}>
                                      {item.createdDate}
                                    </td>
                                    <td>
                                      {formatAmount(item.totalQuantity || 0)}
                                    </td>
                                    <td>{item.fruitQuality}</td>
                                    <td>
                                      {formatAmount(
                                        item.qtyAdjustmentPercentage || 0
                                      )}
                                    </td>
                                    <td>
                                      {formatAmount(item.finalQuantity || 0)}
                                    </td>
                                    <td>{formatAmount(item.rate || 0)}</td>
                                    <td>
                                      {formatAmount(item.totalAmount || 0)}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="9">No procurement data</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* Summary Section */}
                        <div className="row mt-4">
                          {/* Left Table */}
                          <div className="col-md-6">
                            <table className="table table-bordered">
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>A. Total Amount (Good)</strong>
                                  </td>
                                  <td>{formatAmount(totalGoodAmount || 0)}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>B. Total Amount (Bad)</strong>
                                  </td>
                                  <td>{formatAmount(totalBadAmount || 0)}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>C. Total Amount (A + B)</strong>
                                  </td>
                                  <td>{formatAmount(totalC || 0)}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>D. Input Cost</strong>
                                  </td>
                                  <td>
                                    {formatAmount(pdfData?.inputCost || 0)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          {/* Right Table */}
                          <div className="col-md-6">
                            <table className="table table-bordered">
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>E. Administrative Cost</strong>
                                  </td>
                                  <td>
                                    {formatAmount(
                                      pdfData?.administrativeCost || 0
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>F. Total Expense (D + E)</strong>
                                  </td>
                                  <td>{formatAmount(totalF || 0)}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Final Amount (C - F)</strong>
                                  </td>
                                  <td>
                                    <strong>
                                      {formatAmount(
                                        calculatedPayableAmount || 0
                                      )}
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            {/* Print Button */}
            <div className="row no-print">
              <div className="col-12">
                <button
                  type="button"
                  className="btn btn-primary float-right generate-pdf-button"
                  onClick={() =>
                     generatePDF(`farmerInvoiceService_${pdfData?.invoiceNo || "Invoice"}`)
                  }
                >
                  <i className="fas fa-print" /> Generate PDF
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      <AntModal
        title="Farmer Invoice Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default FarmerInvoiceList;
